import React, { useEffect, useState } from "react";
import Header from "../../component/frontend/Header";
import Footer from "./Footer";
import { Link, Route } from "react-router-dom";
import { USER_ID, ERPUrl } from "../../constants";
import "../../css/style.css";
import services from "../../assets/data/services.json";
import { Helmet } from "react-helmet";
import SEO from "../Seo";
import { scAxios, thirdparty } from "../..";
const PatientBillHistory = () => {
  const [fatchdata, setFatchdata] = useState(null);
  const [loading, setLoading] = useState(true);
  console.log(fatchdata);

  useEffect(() => {
    let patientid = localStorage.getItem(USER_ID);
    const fetchData = async () => {
      try {
        const response = await scAxios.get("/PatientBillHistory", {
          params: {
            patientid: patientid,
            fromdate: "2022-01-01",
            todate: "2025-01-01",
            zid: 400010,
          },
        });

        if (response.status === 200) {
          setFatchdata(response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // Initial data fetch
  }, []);
  return (
    <div>
      <SEO
        title="Patient Bill History | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Services"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>

      <Route component={Header} />
      <div id="giveMarginService" style={{ backgroundColor: "#fef3e9" }}>
        <div
          className="allservices"
          // style={{
          //   width: "90vw",
          //   maxWidth: "1140px",
          //   margin: "0 auto",
          //   minHeight: "960px",
          // }}
        >
          <div className="container py-4">
            <div className="d-flex flex-column justify-content-between align-items-center ">
              <div className="1">
                <h3
                  className="text-left "
                  style={{
                    color: "#0C807D",
                    fontSize: "28px",
                    fontWeight: "500",
                    display: "flex",
                    flexDirection: "column",
                    
                  }}
                >
                  Patient Bill History
                  {/* <img
                  src={case_under}
                  style={{ width: "100%", maxWidth: "79px" }}
                  alt=""
                /> */}
                </h3>
              </div>
            </div>

            <div className="table-rep-plugin">
              <div
                className="table-responsive b-0"
                data-pattern="priority-columns"
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh",
                    }}
                  >
                    <img
                      src="https://i.stack.imgur.com/hzk6C.gif"
                      width={300}
                      alt=""
                    />
                  </div>
                ) : fatchdata ? (
                  <table id="tech-companies-1" className="table  table-striped">
                    <thead>
                      <tr>
                        {/* <th>Appointment id</th> */}
                        <th>SL</th>
                        <th data-priority="1">Invoice No</th>
                        <th data-priority="4">Bill No</th>
                        <th data-priority="4">Amount</th>
                        <th>View</th>
                        <th>Date</th>
                        {/* <th data-priority="3">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {fatchdata.length > 0 ? (
                        fatchdata.map((item) => (
                          <tr>
                            <td>{item.SL}</td>
                            <td>{item["Invoice No"]}</td>
                            <td>{item["Bill No"]}</td>
                            <td>{item.Amount}</td>
                            <td>
                              {" "}
                              <a
                                href={ERPUrl + item.View}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="View"
                                className="mr-2"
                              >
                                {" "}
                                <i className="fa fa-eye"></i>
                              </a>
                            </td>
                            <td>{item.Date}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="font_12 txt_col fontweight400 "
                            style={{ textAlign: "center" }}
                          >
                            {" "}
                            There are currently no Packages.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p className="text-centers">No data available.</p>
                )}
                {/* {
                                                            pageNumbers.length > 1
                                                                ?
                                                                <Pagination
                                                                    activePage={this.state.activePage}
                                                                    totalItemsCount={this.state.total}
                                                                    pageRangeDisplayed={5}
                                                                    onChange={this.handlePageChange.bind(this)}
                                                                />
                                                                : ''
                                                        } */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PatientBillHistory;



// WEBPACK FOOTER //
// ./src/component/frontend/PatientBillHistory.js